var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25,
    fill: "#FAF3F3",
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 30.3382C26.5 26.3083 29.6503 23.0714 33.5 23.0714C37.3497 23.0714 40.5 26.3083 40.5 30.3382C40.5 31.3509 40.3011 31.9997 40.0013 32.427C39.7072 32.8461 39.2733 33.1127 38.6718 33.2767C38.0592 33.4436 37.3055 33.495 36.4167 33.4996C35.9755 33.5019 35.5109 33.4929 35.0216 33.4831L34.9877 33.4824C34.5106 33.4728 34.0115 33.4628 33.5 33.4628C32.9885 33.4628 32.4894 33.4728 32.0123 33.4824L31.9784 33.4831C31.4891 33.4929 31.0245 33.5019 30.5833 33.4996C29.6945 33.495 28.9408 33.4436 28.3282 33.2767C27.7267 33.1127 27.2928 32.8461 26.9987 32.427C26.6989 31.9997 26.5 31.3509 26.5 30.3382Z",
    fill: "#C4C4C4",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7857 18.2857C30.7857 17.2 31.1164 16.2363 31.6271 15.5553C32.1378 14.8744 32.805 14.5 33.5 14.5C34.1949 14.5 34.8622 14.8744 35.3728 15.5553C35.8836 16.2363 36.2143 17.2 36.2143 18.2857C36.2143 19.3715 35.8836 20.3352 35.3728 21.0162C34.8622 21.697 34.1949 22.0714 33.5 22.0714C32.805 22.0714 32.1378 21.697 31.6271 21.0162C31.1164 20.3352 30.7857 19.3715 30.7857 18.2857Z",
    fill: "#C4C4C4",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 30.3382C11.5 26.3083 14.6503 23.0714 18.5 23.0714C22.3497 23.0714 25.5 26.3083 25.5 30.3382C25.5 31.3509 25.3011 31.9997 25.0013 32.427C24.7072 32.8461 24.2733 33.1127 23.6718 33.2767C23.0592 33.4436 22.3055 33.495 21.4167 33.4996C20.9755 33.5019 20.5109 33.4929 20.0216 33.4831L19.9877 33.4824C19.5106 33.4728 19.0115 33.4628 18.5 33.4628C17.9885 33.4628 17.4894 33.4728 17.0123 33.4824L16.9784 33.4831C16.4891 33.4929 16.0245 33.5019 15.5833 33.4996C14.6945 33.495 13.9408 33.4436 13.3282 33.2767C12.7267 33.1127 12.2928 32.8461 11.9987 32.427C11.6989 31.9997 11.5 31.3509 11.5 30.3382Z",
    fill: "#C4C4C4",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7857 18.2857C15.7857 17.2 16.1164 16.2363 16.6271 15.5553C17.1378 14.8744 17.805 14.5 18.5 14.5C19.1949 14.5 19.8622 14.8744 20.3728 15.5553C20.8836 16.2363 21.2143 17.2 21.2143 18.2857C21.2143 19.3715 20.8836 20.3352 20.3728 21.0162C19.8622 21.697 19.1949 22.0714 18.5 22.0714C17.805 22.0714 17.1378 21.697 16.6271 21.0162C16.1164 20.3352 15.7857 19.3715 15.7857 18.2857Z",
    fill: "#C4C4C4",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 30.3382C18.5 26.0488 21.8579 22.5714 26 22.5714C30.1421 22.5714 33.5 26.0488 33.5 30.3382C33.5 34.6277 30.1421 33.9628 26 33.9628C21.8579 33.9628 18.5 34.6277 18.5 30.3382Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 30.3382C19 26.3083 22.1503 23.0714 26 23.0714C29.8497 23.0714 33 26.3083 33 30.3382C33 31.3509 32.8011 31.9997 32.5013 32.427C32.2072 32.8461 31.7733 33.1127 31.1718 33.2767C30.5592 33.4436 29.8055 33.495 28.9167 33.4996C28.4755 33.5019 28.0109 33.4929 27.5216 33.4831L27.4877 33.4824C27.0106 33.4728 26.5115 33.4628 26 33.4628C25.4885 33.4628 24.9894 33.4728 24.5123 33.4824L24.4784 33.4831C23.9891 33.4929 23.5245 33.5019 23.0833 33.4996C22.1945 33.495 21.4408 33.4436 20.8282 33.2767C20.2267 33.1127 19.7928 32.8461 19.4987 32.427C19.1989 31.9997 19 31.3509 19 30.3382Z",
    stroke: "black",
    strokeOpacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26,
    cy: 18.2857,
    rx: 3.21429,
    ry: 4.28571,
    transform: "rotate(-180 26 18.2857)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2857 18.2857C23.2857 17.2 23.6164 16.2363 24.1271 15.5553C24.6378 14.8744 25.305 14.5 26 14.5C26.6949 14.5 27.3622 14.8744 27.8728 15.5553C28.3836 16.2363 28.7143 17.2 28.7143 18.2857C28.7143 19.3715 28.3836 20.3352 27.8728 21.0162C27.3622 21.697 26.6949 22.0714 26 22.0714C25.305 22.0714 24.6378 21.697 24.1271 21.0162C23.6164 20.3352 23.2857 19.3715 23.2857 18.2857Z",
    stroke: "black",
    strokeOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9_213",
    x: 7,
    y: 14,
    width: 38,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_213",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDav);
export default __webpack_public_path__ + "static/media/Dav.b7021657c88d2df9cc719fc98acc55f1.svg";
export { ForwardRef as ReactComponent };